var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogo26(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 22,
    viewBox: "0 0 32 22",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.3599 16.3741C18.3147 16.3741 20.71 13.9268 20.71 10.9077C20.71 7.88878 18.3147 5.44141 15.3599 5.44141C12.4051 5.44141 10.0098 7.88878 10.0098 10.9077C10.0098 13.9268 12.4051 16.3741 15.3599 16.3741Z",
    fill: "#00B3FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.24282 3.19394C11.486 -1.06465 18.3667 -1.06465 22.6099 3.19394C26.8599 7.45251 26.8599 14.3571 22.6099 18.6087C18.3667 22.8602 11.486 22.8602 7.24282 18.6017L0.307478 11.6413C-0.102493 11.2294 -0.102493 10.5662 0.307478 10.1543L7.24282 3.19394ZM9.68214 16.5631C12.7979 19.6907 17.8542 19.6907 20.97 16.5631C24.0858 13.4355 24.0858 8.36709 20.9632 5.23946C17.8474 2.11184 12.7911 2.11184 9.67531 5.23946L4.578 10.3498C4.27736 10.657 4.27736 11.1456 4.578 11.4458L9.68214 16.5631Z",
    fill: "#00B3FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M28.6436 7.04015L31.6978 10.1608C32.101 10.5727 32.101 11.2359 31.6978 11.6548L28.6436 14.7754C28.4659 14.957 28.1585 14.7894 28.2131 14.5311C28.7392 12.1504 28.7392 9.66514 28.2131 7.28453C28.1515 7.02619 28.459 6.85166 28.6436 7.04015Z",
    fill: "#00B3FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo26);
export default __webpack_public_path__ + "static/media/logo26.ac66a2f69fca7ef390d1aa911ec0e6f5.svg";
export { ForwardRef as ReactComponent };